import { AxiosResponse } from 'axios';
import { flatten } from 'lodash';
import { all, put } from 'redux-saga/effects';
import { createAsyncAction } from 'typesafe-actions';
import sagaApi, { PayloadApiRequest } from '@lib/actions/sagaApi';

import practiceAnalyzerResource from 'resources/practiceAnalyzerResource';

export interface FetchPracticeAnalyzerLinearRequestPayload extends Omit<PayloadApiRequest<any>, 'meta'> {
  meta: {
    compareType: string;
    callbackSuccess: (responses: AxiosResponse[]) => void;
  };
}

const fetchPracticeAnalyzerLinearData = createAsyncAction(
  'app/fetchPracticeAnalyzerLinearData/REQUEST',
  'app/fetchPracticeAnalyzerLinearData/SUCCESS',
  'app/fetchPracticeAnalyzerLinearData/FAILURE',
  'app/fetchPracticeAnalyzerLinearData/CANCEL',
)<FetchPracticeAnalyzerLinearRequestPayload, AxiosResponse[], Error, any>();

// saga
export function* sagaFetchPracticeAnalyzerLinearData(
  action: ReturnType<typeof fetchPracticeAnalyzerLinearData.request>,
) {
  const {
    payload: { meta, ...payload },
  } = action;

  const promises = [
    sagaApi({
      url: `${practiceAnalyzerResource.url}/metric/${meta.compareType}/daily`,
      ...payload,
    }),
  ];
  const responses: AxiosResponse[] = yield all(flatten(promises));

  if (meta && meta.callbackSuccess) {
    meta.callbackSuccess(responses);
  }
  yield put(fetchPracticeAnalyzerLinearData.success(responses));
}

export default fetchPracticeAnalyzerLinearData;
